import * as moment from "moment";
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RefreshDate } from '../../../core/shared/model/RefreshDate';
import { StatementsService } from '../../statements/statements.service';
import { RequestType } from "../../../core/shared/model/RequestType";
import { UserService } from "../../../core/services/user.service";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { FSInvoiceDialogService } from "../../../core/services/fsinvoice.dialog.service";
import { LoggingService } from "mclane-apptemplate-lib";
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';
import { eyeIcon } from '@progress/kendo-svg-icons';


@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {

  viewOnly: any = eyeIcon;
  selectedRequestType: string;
  selectedDateType: string;
  selectedInvType: string;
  downloaded: boolean = false;
  startDate: string;
  endDate: string;
  dateRangeChk: boolean = false;
  fromRange: string;
  toRange: string;
  toDate: Date;
  selectedStartDateInvoice: Date = moment().toDate();
  selectedEndDateInvoice: Date;
  currentDate: RefreshDate = new RefreshDate();
  selectFormInvoice: FormGroup;
  maxEndDate: Date = moment().add(3, 'months').toDate();
  minEndDate: Date = moment().subtract(18, 'months').toDate();
  bulkSelect: boolean = false;
  parentCustomerNumbers: string[] = [];

  public requesttypes: RequestType[] = [
    {id: 'I', text: 'Search by Invoice Number Range', checked: true},
    {id: 'O', text: 'Search by Order Number Range', checked: false},
    {id: 'D', text: 'Date Range', checked: false},
  ];

  public daterequesttypes: RequestType[] = [
    {id: 'ID', text: 'Invoice Date Range', checked: false},
    {id: 'ND', text: 'Net Due Date Range', checked: false},
    {id: 'DD', text: 'Discount Due Date Range', checked: false},
  ];

  get nextDisabled(): boolean {
    return !this.isEndDateValid;
  }

  get isViewOnly(): boolean {
    if (this.selectedStartDateInvoice < this.minEndDate) {
      return true;
    }
    return false;
  }

  get isEndDateValid(): boolean {
    if (this.selectedEndDateInvoice > this.maxEndDate) {
      return false;
    }
    return true;
  }


  constructor(public userService: UserService, public statementsService: StatementsService, private _route: ActivatedRoute, private _router: Router,
              public fsInvoiceDialog: FSInvoiceDialogService, public console: LoggingService, public loadingIndicator: LoadingIndicatorHelper) {
  }

  showOptions(event) {
    event.valueMerger();
  }

  ngOnInit() {
    this.bulkSelect = this.userService.getBulkSelect();
    this.parentCustomerNumbers = this.userService.getSelectedInvoiceParents();
    if (this.parentCustomerNumbers.length === 0) {
      this._router.navigate(['/invoices']);
    } else {

      this.initForm();
      if (this.bulkSelect) {
        this.selectFormInvoice.get('requestType').setValue('D');
        this.dateRangeChk = true;
        
        // Get all stores under the parent customer
        const storesUnderParent = this.userService.getStoresOriginal().filter(store => store.billToSiteNumber in this.parentCustomerNumbers);
        if (storesUnderParent.length > 0) {
          this.userService.setSelectedInvoiceStores(storesUnderParent.map(store => store.shipToSiteNumber));
          this.userService.setSelectedInvoiceStoresMap(new Map(storesUnderParent.map(store => [store.shipToSiteNumber, store])));
          this.statementsService.getAsOfDate('D').subscribe(retDate => {
                this.currentDate = Object.assign(new RefreshDate(), retDate);
                this.loadingIndicator.hide();
          })
        }
      }
    }
  }

  initForm() {
    if (this.userService.getSelectedStartDateInvoice()) {
      this.selectedStartDateInvoice = moment(this.userService.getSelectedStartDateInvoice()).toDate();
      this.startDate = this.selectedStartDateInvoice.toString();
      if (this.startDate == "Start Date" ) {
        this.startDate = null;
      }
    }

    if (this.userService.getSelectedEndDateInvoice()) {
      this.selectedEndDateInvoice = moment(this.userService.getSelectedEndDateInvoice()).toDate();
      this.endDate = this.selectedEndDateInvoice.toString();
      if (this.endDate == "End Date" ) {
        this.endDate = null;
      }
    }

    this.selectedEndDateInvoice = moment(this.userService.getSelectedEndDateInvoice()).toDate();
    this.selectedInvType = this.userService.getSelectedInvTypeInvoice();
    this.selectedRequestType = this.userService.getSelectedRequestTypeInvoice();
    this.dateRangeChk = this.userService.getDateRangeChkInvoice();
    this.fromRange = this.userService.getFromRange();
    this.toRange = this.userService.getToRange();
    this.downloaded = this.userService.getDownloaded();
    this.selectFormInvoice = new FormGroup({
      invoiceType: new FormControl(this.selectedInvType, [Validators.required]),
      requestType: new FormControl(this.selectedRequestType, Validators.required),
      downloaded: new FormControl(this.downloaded),
      fromRange: new FormControl(this.fromRange, [Validators.required]),
      toRange: new FormControl(this.toRange, [Validators.required]),
      selectedStartDateInvoice: new FormControl(this.selectedStartDateInvoice, [Validators.required]),
      selectedEndDateInvoice: new FormControl(this.selectedEndDateInvoice, [Validators.required]),
    });
    this.refreshForm();
  }

  nextClicked() {
    this.userService.setSelectedRequestTypeInvoice(this.selectedRequestType);
    this.userService.setSelectedDateType(this.selectedDateType);
    this.userService.setSelectedStartDateInvoice(this.selectedStartDateInvoice);
    this.userService.setSelectedEndDateInvoice(this.selectedEndDateInvoice);
    this.userService.setFromRange(this.fromRange);
    this.userService.setToRange(this.toRange);
    this.userService.setDownloaded(this.downloaded);
    this.userService.setSelectedInvTypeInvoice(this.selectedInvType);
    this.userService.setDateRangeChkInvoice(this.dateRangeChk);

    if (this.bulkSelect) {
      const parentCustomerNumber = this.userService.getSelectedInvoiceParents();
      if (parentCustomerNumber.length > 0) {
        const storesUnderParent = this.userService.getStoresOriginal().filter(store => store.billToSiteNumber in parentCustomerNumber);
        if (storesUnderParent.length > 0) {
          this.userService.setSelectedInvoiceStores(storesUnderParent.map(store => store.shipToSiteNumber));
          this.userService.setSelectedInvoiceStoresMap(new Map(storesUnderParent.map(store => [store.shipToSiteNumber, store])));
        }
      }
    }

    let navigationExtras: NavigationExtras = {
      queryParams: {}
    };

    if (this.dateRangeChk && this.selectFormInvoice.get('selectedStartDateInvoice').value == 'Start Date') {
      this.fsInvoiceDialog.showMessageDialog('Start Date', 'You must enter a Start Date');
    } else {
      this._router.navigate(['/invoiceinvoices'], navigationExtras);
    }
  }

  backClicked() {
    this.userService.setBackClicked(true);
    this._router.navigate(['/invoices']);
  }

  // fromRangeChange(value: string) {
  //  if(this.selectFormInvoice.get('requestType').value === 'I' || this.selectFormInvoice.get('requestType').value === 'O') {
  //     this.fromRange = value
  //   }
  // }

  // toRangeChange(value: string) {
  //  if(this.selectFormInvoice.get('requestType').value === 'I' || this.selectFormInvoice.get('requestType').value === 'O') {
  //     this.toRange = value
  //   }
  // }

  private refreshForm() {
    this.selectFormInvoice.get('requestType').valueChanges
      .subscribe((value) => {
        if (value == null) return;
        this.selectedRequestType = value;
      });

    this.selectFormInvoice.get('requestType').valueChanges
      .subscribe((value) => {
        if (value == null) {
          return;
        }
        if (value == 'D') {
          this.dateRangeChk = true;
        } else {
          this.dateRangeChk = false;
        }
        this.selectedRequestType = value;
      });

    this.selectFormInvoice.get('invoiceType').valueChanges
      .subscribe((value) => {
        if(value == null) return;
        if(this.selectedRequestType != 'D') {
          this.selectedInvType = 'I';
          this.dateRangeChk = false;
        } else {
          this.dateRangeChk = true;
          this.selectedInvType = value;
        }
      });

    this.selectFormInvoice.get('selectedStartDateInvoice').valueChanges
      .subscribe((value) => {
        if(value == null) return;
        this.selectedStartDateInvoice = value;
     });

   this.selectFormInvoice.get('selectedEndDateInvoice').valueChanges
     .subscribe((value) => {
       if(value == null) return;
       this.selectedEndDateInvoice = value;
     });

    this.selectFormInvoice.get('downloaded').valueChanges
      .subscribe((value) => {
        if (value == null) return;
        this.downloaded = value;
      });

    this.selectFormInvoice.get('fromRange').valueChanges
      .subscribe((value) => {
        if(value == null) return;
        this.fromRange = value;
      });

    this.selectFormInvoice.get('toRange').valueChanges
      .subscribe((value) => {
        if(value == null) return;
        this.toRange = value;
      });
  }

  cancelClicked() {
    this._router.navigate(['/home']);
  }
}
